import React from 'react';
import moment from 'moment';
import { TAnnex6V2Record } from '../../../../../../../redux/app/annex6-v2/@types';
import { TAnnex6V2GroupL1 } from '../../../../../../../redux/app/annex6-v2/groups/group-l';
import Annex6V2TableRows from '../../_elements_v2/Annex6V2TableRows';

type OwnProps = {
    annex6V2Record: TAnnex6V2Record;
    isStrikedOff?: boolean;
    theme?: 'light' | 'dark';
};
type Annex6V2GroupL1PreviewProps = OwnProps;

function Annex6V2GroupL1Preview(props: Annex6V2GroupL1PreviewProps) {
    const record = props.annex6V2Record as TAnnex6V2GroupL1;
    const operationDate = moment(record.selectedDate, 'YYYY-MM-DD').format(
        'DD-MMM-YYYY'
    );

    function renderMain() {
        const tableRows = [
            [operationDate, 'L', '1', renderItemP1()],
            [null, null, 'NOTE', record.remarks],
        ];

        return (
            <Annex6V2TableRows
                record={record}
                tableRows={tableRows}
                theme={props.theme}
            />
        );
    }

    function renderItemP1() {
        const { accidentalOrExceptionalOperation, fonarSummary } =
            record.itemL1P1;
        return (
            <h4 className="font-medium uppercase">
                {accidentalOrExceptionalOperation && (
                    <p>{accidentalOrExceptionalOperation}</p>
                )}
                {accidentalOrExceptionalOperation && fonarSummary && (
                    <p className="mb-1" />
                )}
                {fonarSummary && <p>{fonarSummary}</p>}
            </h4>
        );
    }

    return renderMain();
}

export default Annex6V2GroupL1Preview;
